import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useViewport } from '../../hooks/useViewport';

interface PlatformPieChartProps {
  data: Record<string, number>;
  height?: number;
}

const COLORS: Record<string, string> = {
  google: '#4285F4',
  yelp: '#d32323',
  realself: '#00a6a6',
  default: '#c6a664',
};

const PlatformPieChart: React.FC<PlatformPieChartProps> = ({ data, height = 300 }) => {
  const { isMobile, isTablet } = useViewport();

  const chartData = Object.entries(data).map(([name, value]) => ({
    name: name.charAt(0).toUpperCase() + name.slice(1),
    value,
    color: COLORS[name.toLowerCase()] || COLORS.default,
  }));

  // Responsive values
  const outerRadius = isMobile ? 60 : isTablet ? 70 : 80;
  const chartHeight = isMobile ? 200 : height;
  const fontSize = isMobile ? 10 : 12;

  // Only show labels on desktop
  const renderLabel = isMobile ? false : (entry: { name: string; value: number }) => `${entry.name}: ${entry.value}`;

  return (
    <div>
      <ResponsiveContainer width="100%" height={chartHeight}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={!isMobile}
            label={renderLabel}
            outerRadius={outerRadius}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontFamily: 'Open Sans',
              fontSize: fontSize,
            }}
          />
        </PieChart>
      </ResponsiveContainer>
      {/* Custom legend for mobile */}
      {isMobile && (
        <div className="flex flex-wrap justify-center gap-3 mt-2">
          {chartData.map((entry, index) => (
            <div key={index} className="flex items-center gap-1.5">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry.color }}
              />
              <span className="font-['Open_Sans'] text-xs text-[#767472]">
                {entry.name}: {entry.value}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlatformPieChart;
